import { getGPSFromGLNString } from './getGPSFromGLN';

export function isValidLatitude(value: number | undefined | null): boolean {
	if (value === undefined || value === null) {
		return false;
	}
	if (value < -90) {
		return false;
	}
	if (value > 90) {
		return false;
	}
	return true;
}

export function isValidLongitude(value: number | undefined | null): boolean {
	if (value === undefined || value === null) {
		return false;
	}
	if (value < -180) {
		return false;
	}
	if (value > 180) {
		return false;
	}
	return true;
}

export function isValidGLNString(value: string | undefined): boolean {
	const gps = getGPSFromGLNString(value);

	if (!isValidLatitude(gps?.latitude)) {
		return false;
	}

	if (!isValidLongitude(gps?.longitude)) {
		return false;
	}

	return true;
}
